// Service fees and promos are not here: both screens still edit local state only
// (no API behind Save/Delete), so an event there would count saves that never
// happened. Add them when those screens are wired to the backend.
export const commercials_events = {
  partner_markup_rule_save: {
    category: 'Partner commercials',
    action: 'Operator creates or updates a markup rule',
    label: 'partner_markup_rule_save',
  },
  partner_promo_code_save: {
    category: 'Partner commercials',
    action: 'Operator creates or updates a promo code',
    label: 'partner_promo_code_save',
  },
  partner_promo_code_toggle: {
    category: 'Partner commercials',
    action: 'Operator activates or deactivates a promo code',
    label: 'partner_promo_code_toggle',
  },
  partner_gst_rates_save: {
    category: 'Partner commercials',
    action: 'Operator saves GST rates',
    label: 'partner_gst_rates_save',
  },
};
